import { call, put, takeLatest } from "redux-saga/effects";
import { fetchAll } from "../../../services/exam";
import { networkErrorHandler } from "../../../utils/errorHandlers";
import {
  getAllExamsStart,
  getAllExamsSuccess,
  getAllExamsFailure,
} from "../reducer";

export function* getAllExam({ payload }) {
  const response = yield call(fetchAll, payload);
  const { success, raw, message } = response;

  if (success) {
    yield put(getAllExamsSuccess(raw));
  } else {
    yield put(getAllExamsFailure(message || raw?.error));
    networkErrorHandler(response?.statusCode, message || raw?.error);
  }
}

export default function* onGetAllExam() {
  yield takeLatest(getAllExamsStart.type, getAllExam);
}
